import React from 'react'
import { object, func } from 'prop-types'

import R from 'ramda'
import moment from 'moment'

import compose from 'recompose/compose'
import getContext from 'recompose/getContext'
import withState from 'recompose/withState'
import withHandlers from 'recompose/withHandlers'
import withProps from 'recompose/withProps'

import interceptUpdater from 'coact-utils/interceptUpdater'

import arrangeData from './arrangeData'

import View from './AttendanceChecker'

// import download from 'downloadjs'


function fetchData (server, url, query) {
  return server.get({ url, query: { query, limit: 3000 } })
    .then(({ data }) => data)
}

// eslint-disable-next-line no-extra-parens
const clickFetch = ({
  fetchingQueries, server, setRecords, setData, setComments, stafferById, dateByStr,
}) => async () => {
  try {
    const { gateQuery, leaveQuery, overtimeQuery, commentQuery } = fetchingQueries
    const commentData = await fetchData(server, '/api/model/comments', commentQuery)
    const commentByDate = R.indexBy(
      ({ date }) => moment(date).format('YYYY-MM-DD'),
      commentData,
    )
    setComments(commentByDate)

    const gateData = await fetchData(server, '/api/model/gateRecords', gateQuery)
    const leaveData = await fetchData(server, '/api/model/leaveRecords', leaveQuery)
    const overtimeData = await fetchData(server, '/api/model/overtimeRecords', overtimeQuery)

    // download(JSON.stringify(gateData, null, 2), 'gateData.json', 'text/plain')

    setData(arrangeData(gateData, leaveData, overtimeData, stafferById, gateQuery, dateByStr))
  } catch (err) {
    console.error('clickFetch Error:', err)
    throw err
  }
}

const createGate = ({ server, clickFetch }) => stafferRef => async time => {
  await server.post({
    url: '/api/model/gateRecords',
    data: { stafferRef, time, source: '輸入' },
  })
  clickFetch()
}

const createComment = ({ server }) => stafferRef => async doc => {
  const { _id, date, comment } = doc
  const endPoint = '/api/model/comments'
  const [method, url] = _id ? ['patch', `${endPoint}/${_id}`] : ['post', endPoint]

  const response = await server[method]({
    url,
    data: { date, comment, stafferRef },
  })

  return response.data
}

const delGate = ({ server, clickFetch }) => async (id) => {
  if (window.confirm('delete data?')) {
    const url = `/api/model/gateRecords/${id}`
    await server.del({ url })
    clickFetch()
  }
}

const queryEditorProps = {
  fields: ['time', 'stafferRef'],
  schema: {
    type: 'object',
    contents: {
      time: { name: '日期', type: 'Date', format: 'YYYY/MM/DD' },
      stafferRef: {
        name: '姓名',
        type: 'ObjectId',
        reference: 'staffers',
        refKeys: ['name'],
      },
    },
  },
}

function buildLeaveQuery (query) {
  const leaveQuery = { }

  if (query.stafferRef) {
    leaveQuery.stafferRef = query.stafferRef
  }

  if (query.time) {
    if (query.time.$lte) leaveQuery.start = { $lte: query.time.$lte }
    if (query.time.$gte) leaveQuery.end = { $gte: query.time.$gte }
  }

  return leaveQuery
}
function buildOvertimeQuery (query) {
  const overtimeQuery = { }

  if (query.stafferRef) {
    overtimeQuery.stafferRef = query.stafferRef
  }

  if (query.time) {
    if (query.time.$lte) overtimeQuery.start = { $lte: query.time.$lte }
    if (query.time.$gte) overtimeQuery.end = { $gte: query.time.$gte }
  }

  return overtimeQuery
}
function buildCommentQuery (query) {
  const commentQuery = { }

  if (query.stafferRef) {
    commentQuery.stafferRef = query.stafferRef
  }

  if (query.time) {
    commentQuery.date = query.time
  }

  return commentQuery
}

function controller (Component) {
  class AttendanceCheckerCtrl extends React.Component {
    async componentDidMount () {
      const { server, setStaffers, setDates } = this.props
      const staffers = await fetchData(server, '/api/model/staffers')
      const dates = await fetchData(server, '/api/model/dates')

      setStaffers(R.indexBy(R.prop('_id'), staffers))
      setDates(R.indexBy(s => moment(s.date).format('YYYY-MM-DD'), dates))
    }
    render () {
      return React.createElement(Component, this.props)
    }
  }

  AttendanceCheckerCtrl.propTypes = {
    server: object.isRequired,
    setStaffers: func.isRequired,
  }

  return AttendanceCheckerCtrl
}

const AttendanceChecker = compose(
  getContext({ server: object }),

  withState('stafferById', 'setStaffers', { }),
  withState('dateByStr', 'setDates', { }),

  withState('query', 'setQuery', { }),
  withState('fetchingQueries', 'setFetchingQuery', { }),

  withState('data', 'setData', []),
  withState('commentByDate', 'setComments', { }),

  withProps(queryEditorProps),
  interceptUpdater('setQuery', ({ setFetchingQuery }) => query => {
    const gateQuery = query
    const leaveQuery = buildLeaveQuery(query)
    const overtimeQuery = buildOvertimeQuery(query)
    const commentQuery = buildCommentQuery(query)

    setFetchingQuery({ gateQuery, leaveQuery, overtimeQuery, commentQuery })
    return query
  }),

  withHandlers({ clickFetch }),
  withHandlers({ createGate, delGate, createComment }),
  controller,
)(View)

AttendanceChecker.displayName = 'AttendanceChecker'

export default AttendanceChecker



// WEBPACK FOOTER //
// ./src/components/AttendanceChecker/index.js